<template>
  <div id="page">
    <AvbHeader />
  </div>
</template>

<script>
import AvbHeader from '../components/Avb-Header'
export default {
    name: 'Results',
    components: {
        AvbHeader
    },

}
</script>

<style>

</style>
